<template>
  <div
    class="modal fade"
    id="filter-recruitment-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content m-t100">
        <div class="modal-header">
          <h3 class="modal-title" id="myModalLabel">Filter Data</h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="content-form">
            <div class="form-group col-lg-12 col-md-12 col-sm-12">
              <label class="control-label m-r15" htmlFor="createdOn"
                >Created On</label
              >
              <div class="col-lg-12 col-md-12 col-sm-12 nopadding text-wrap">
                <label for="all" class="radio-inline m-r10">
                  <input
                    type="radio"
                    id="all"
                    value=""
                    v-model="createdDate.filterType"
                  />
                  All
                </label>
                <label for="lastWeek" class="radio-inline m-r10">
                  <input
                    type="radio"
                    id="lastWeek"
                    value="Last One Week"
                    v-model="createdDate.filterType"
                  />
                  Last One Week
                </label>
                <label for="lastMonth" class="radio-inline m-r10">
                  <input
                    type="radio"
                    id="lastMonth"
                    value="Last One Month"
                    v-model="createdDate.filterType"
                  />
                  Last One Month
                </label>
                <label for="lastThreeMonth" class="radio-inline m-r10">
                  <input
                    type="radio"
                    id="lastThreeMonth"
                    value="Last Three Months"
                    v-model="createdDate.filterType"
                  />
                  Last Three Months
                </label>
                <label for="lastSixMonths" class="radio-inline m-r10">
                  <input
                    type="radio"
                    id="lastSixMonths"
                    value="Last Six Months"
                    v-model="createdDate.filterType"
                  />
                  Last Six Months
                </label>
                <label for="lastYear" class="radio-inline m-r15">
                  <input
                    type="radio"
                    id="lastYear"
                    value="Last One Year"
                    v-model="createdDate.filterType"
                  />
                  Last One Year
                </label>
                <label for="custom" class="radio-inline m-r10">
                  <input
                    type="radio"
                    id="Custom"
                    value="Custom"
                    v-model="createdDate.filterType"
                  />
                  Custom
                </label>
              </div>
            </div>
            <div v-if="createdDate.filterType === 'Custom'">
              <div class="form-group col-lg-12 col-md-12 col-sm-12">
                <label class="control-label" htmlFor="fromDate"
                  >From Date</label
                >
                <date-picker
                  v-model="createdDate.fromDate"
                  id="fromDate"
                  :config="config"
                  @dp-hide="dateRequired('fromDate')"
                ></date-picker>
                <p v-if="fromDateFlag" class="alert-sm alert-danger">
                  This field is required
                </p>
              </div>
              <div class="form-group col-lg-12 col-md-12 col-sm-12">
                <label class="control-label" htmlFor="toDate">To Date</label>
                <date-picker
                  v-model="createdDate.toDate"
                  id="toDate"
                  :config="config"
                ></date-picker>
              </div>
              <p v-if="!isDateValid" class="alert-sm alert-danger">
                From date should not be greater than To date
              </p>
            </div>

            <div>
              <div class="form-group col-lg-12 col-md-12 col-sm-12">
                <label class="control-label m-r15" htmlFor="status"
                  >Status</label
                >
                <div class="col-lg-12 col-md-12 col-sm-12 nopadding text-wrap">
                  <label class="radio-inline m-r10">
                    <input type="radio" value="" v-model="moreFilters.status" />
                    All
                  </label>
                  <label class="radio-inline m-r10">
                    <input
                      type="radio"
                      value="inProgress"
                      v-model="moreFilters.status"
                    />
                    In Progress
                  </label>
                  <label class="radio-inline m-r10">
                    <input
                      type="radio"
                      value="Completed"
                      v-model="moreFilters.status"
                    />
                    Completed
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer text-center">
          <button
            :disabled="disableButton"
            type="button"
            class="btn btn-cp"
            @click="onApplyFilter"
            data-dismiss="modal"
          >
            Apply
          </button>
          <button
            type="button"
            class="btn btn-cp"
            data-dismiss="modal"
            @click="onResetFilter"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datePicker from "vue-bootstrap-datetimepicker";
import { required } from "vuelidate/lib/validators";

/**
 * @memberOf module:CampusRecruitment
 * @namespace components.filter_data_modal_rec
 * @description Filter data modal component
 */
export default {
  props: ["filterOptions", "updateFilterOptions"],
  data() {
    return {
      createdDate: {
        filterType: "",
        fromDate: null,
        toDate: null,
      },
      moreFilters: {
        status: "",
      },
      fromDateFlag: false,
      toDateFlag: false,
      config: {
        format: "DD MMMM YYYY",
        maxDate: new Date(),
        showClear: true,
        showClose: true,
      },
    };
  },
  components: {
    datePicker,
  },
  validations() {
    const createdDate = {
      filterType: {
        required,
      },
    };
    if (this.createdDate.filterType === "Custom") {
      createdDate.fromDate = {
        required,
      };
    }
    return {
      createdDate,
    };
  },
  computed: {
    disableButton() {
      if (
        this.createdDate.filterType ||
        this.moreFilters.status !== "inProgress"
      ) {
        if (
          this.createdDate.filterType &&
          this.createdDate.filterType == "Custom"
        ) {
          if (this.createdDate.fromDate) {
            return !this.isDateValid;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
      return true;
    },
    isDateValid() {
      if (this.createdDate.fromDate && this.createdDate.toDate) {
        return new Date(this.createdDate.fromDate) >
          new Date(this.createdDate.toDate)
          ? false
          : true;
      }
      return true;
    },
  },
  methods: {
    /**
     * @memberOf module:CampusRecruitment.components.filter_data_modal_rec
     * @description Validation for from date and to date
     */
    dateRequired(dateType) {
      if (dateType === "fromDate") {
        this.fromDateFlag = !this.createdDate.fromDate ? true : false;
      } else {
        this.toDateFlag = !this.createdDate.toDate ? true : false;
      }
    },
    /**
     * @memberOf module:CampusRecruitment.components.filter_data_modal_rec
     * @description Applies filter to the data
     */
    onApplyFilter() {
      let days;
      let curDate = new Date();
      switch (this.createdDate.filterType) {
        case "Last One Week":
          days = 7;
          this.createdDate.toDate = curDate;
          this.createdDate.fromDate = new Date(
            curDate.getTime() - days * 24 * 60 * 60 * 1000
          );
          break;
        case "Last One Month":
          days = 30;
          this.createdDate.toDate = curDate;
          this.createdDate.fromDate = new Date(
            curDate.getTime() - days * 24 * 60 * 60 * 1000
          );
          break;
        case "Last Three Months":
          days = 90;
          this.createdDate.toDate = curDate;
          this.createdDate.fromDate = new Date(
            curDate.getTime() - days * 24 * 60 * 60 * 1000
          );
          break;
        case "Last Six Months":
          days = 180;
          this.createdDate.toDate = curDate;
          this.createdDate.fromDate = new Date(
            curDate.getTime() - days * 24 * 60 * 60 * 1000
          );
          break;
        case "Last One Year":
          days = 365;
          this.createdDate.toDate = curDate;
          this.createdDate.fromDate = new Date(
            curDate.getTime() - days * 24 * 60 * 60 * 1000
          );
          break;
        case "Custom":
          if (this.createdDate.toDate == null) {
            this.createdDate.toDate = null;
          } else {
            this.createdDate.toDate = new Date(this.createdDate.toDate);
          }
          this.createdDate.fromDate = new Date(this.createdDate.fromDate);
          break;
        case "":
          this.createdDate.fromDate = null;
          this.createdDate.toDate = null;
          break;
      }
      this.updateFilterOptions({
        createdDate: { ...this.createdDate },
        moreFilters: { ...this.moreFilters },
      });
    },
    onResetFilter() {
      this.createdDate = { filterType: "", fromDate: null, toDate: null };
      this.moreFilters = { status: "inProgress" };
      this.updateFilterOptions({
        createdDate: { ...this.createdDate },
        moreFilters: { ...this.moreFilters },
      });
    },
  },
  watch: {
    filterOptions: {
      immediate: true,
      handler(value) {
        this.createdDate = { ...value.createdDate };
        this.moreFilters = { ...value.moreFilters };
      },
    },
  },
  beforeDestroy() {
    $("#filter-recruitment-modal").modal("hide");
    $(".modal-backdrop").hide();
    $("body").removeClass("modal-open");
  },
};
</script>
